.<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Atributes />
  </div>
</template>
  
  <script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Atributes from "../../components/GestionEmpleados/Views/Employee/Atributes.vue";
export default {
  components: { LandingToolbar, Atributes },
};
</script>
  
  